import React from "react";
import { FormControl, FormControlLabel, FormLabel, Grid, Radio, RadioGroup, Typography } from "@material-ui/core";
import { GridSize } from "@material-ui/core/Grid";

interface RadioGroupFieldProps {
  title?: string;
  name: string;
  value?: string | boolean;
  options: Array<{ value: boolean | string; label: string }>;
  handleChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  disabled?: boolean;
  classes: any;
  xs?: GridSize;
  labelContent?: React.ReactNode;
}

const RadioGroupField: React.FC<RadioGroupFieldProps> = ({
  title,
  name,
  value,
  options,
  handleChange = () => {},
  disabled,
  classes,
  xs = 3,
  labelContent,
}) => (
  <Grid item xs={xs}>
    <FormControl component="fieldset">
      <FormLabel component="legend" className={classes.serviceTypeContentTitle}>
        {labelContent || <Typography>{title ?? ""}</Typography>}
      </FormLabel>
      <RadioGroup name={name} value={value ?? false} onChange={handleChange}>
        {options.map((option) => (
          <FormControlLabel
            key={option.label}
            value={option.value}
            control={<Radio color="primary" />}
            label={option.label}
            classes={{ label: classes.formControlLabel }}
            disabled={disabled}
          />
        ))}
      </RadioGroup>
    </FormControl>
  </Grid>
);

export default RadioGroupField;
